import { cva } from 'cva';
import { getFullPermutation } from '@tencent/ywwriter-common/lib/utils/array';
export const buttonVariants = cva({
    base: [
        '@inline-flex',
        '@items-center',
        '@justify-center',
        '@whitespace-nowrap',
        '@rounded',
        '@font-regular',
        '@ring-offset-background',
        '@transition-colors',
        'focus-visible:@outline-none',
        'focus-visible:@ring-2',
        'focus-visible:@ring-ring',
        'focus-visible:@ring-offset-2',
        'disabled:@cursor-not-allowed',
    ],
    variants: {
        variant: {
            filled: '',
            outlined: '@border @border-input',
            text: 'hover:@bg-overlay-accent-hover active:@bg-overlay-accent-pressed',
            link: '',
        },
        state: {
            normal: '',
            emphasis: '',
            danger: '',
        },
        size: {
            sm: '@text-caption @px-1 @py-0.5 [&>*:nth-child(n+2)]:@ml-0.5 [&>svg]:@w-[14px] [&>svg]:@h-[14px]',
            md: '@text-b2 @font-medium @px-1.5 @py-1 [&>*:nth-child(n+2)]:@ml-1',
            lg: '@text-b2 @font-medium @px-2 @py-1.5 [&>*:nth-child(n+2)]:@ml-1.5',
        },
        icon: {
            '': '',
            square: '',
            circle: '@rounded-full',
        }
    },
    compoundVariants: [
        {
            icon: ['circle', 'square'],
            size: 'md',
            class: '@px-1.5 @py-1.5',
        },
        {
            icon: ['circle', 'square'],
            size: 'sm',
            class: '@px-1 @py-1',
        },
        {
            icon: ['circle', 'square'],
            size: 'lg',
            class: '@px-2 @py-2',
        },
        {
            variant: ['filled', 'outlined'],
            size: ['md', 'lg'],
            icon: [''],
            class: '@min-w-20',
        },
        {
            variant: 'filled',
            state: 'normal',
            class: '@bg-overlay-primary @text-primary-foreground hover:@bg-overlay-primary-hover active:@bg-overlay-primary-pressed disabled:@bg-overlay-primary-disabled'
        },
        {
            variant: 'filled',
            state: 'danger',
            class: '@bg-overlay-destructive @text-destructive-foreground hover:@bg-overlay-destructive-hover active:@bg-overlay-destructive-pressed disabled:@bg-overlay-destructive-disabled'
        },
        {
            variant: 'outlined',
            state: ['normal', 'danger'],
            class: '@bg-overlay-accent hover:@bg-overlay-accent-hover active:@bg-overlay-accent-pressed disabled:@bg-overlay-accent-disabled'
        },
        {
            variant: 'outlined',
            state: 'normal',
            class: '@border-outline @text-outline-foreground hover:@border-outline-hover active:@border-outline-pressed disabled:@border-outline-disabled disabled:@text-outline-foreground-disabled'
        },
        {
            variant: 'outlined',
            state: 'danger',
            class: '@border-stamp @text-stamp-foreground hover:@border-stamp-hover active:@border-stamp-pressed disabled:@border-stamp-disabled disabled:@text-stamp-foreground-disabled'
        },
        {
            variant: ['text', 'link'],
            state: 'normal',
            class: '@text-accent-foreground disabled:@text-accent-foreground-disabled'
        },
        {
            variant: ['text', 'link'],
            state: 'emphasis',
            class: '@text-primary disabled:@text-primary-disabled'
        },
        {
            variant: ['text', 'link'],
            state: 'danger',
            class: '@text-destructive disabled:@text-destructive-disabled'
        },
        {
            variant: 'link',
            size: 'lg',
            class: '@underline @underline-offset-[3px]'
        },
        {
            variant: 'link',
            size: ['md', 'lg', 'sm'],
            class: '@p-0 @font-regular'
        },
        {
            variant: 'text',
            size: ['md', 'lg', 'sm'],
            class: ['disabled:@bg-overlay-[transparent]']
        }
    ],
    defaultVariants: {
        variant: 'filled',
        size: 'md',
        state: 'normal',
        icon: '',
    },
});
export const buttonVariantNameMap = {
    filled: '填充',
    outlined: '描边',
    text: '文字',
    link: '链接',
};
export const bannedButtonVariants = [
    { variant: 'filled', state: 'emphasis' },
    { variant: 'outlined', state: 'emphasis' },
    { variant: 'link', icon: 'circle' },
    { variant: 'link', icon: 'square' },
];
const toEntry = (key, list) => list.map(v => ({ [key]: v }));
export const allButtonVariants = {
    variant: ['filled', 'outlined', 'text', 'link'],
    state: ['normal', 'emphasis', 'danger'],
    size: ['sm', 'md', 'lg'],
    icon: ['', 'square', 'circle'],
    overlay: [null, 'var(--grey-1)'],
};
export const allButtonVariantsList = getFullPermutation(Object.entries(allButtonVariants).map(([key, list]) => toEntry(key, list)))
    .map(variants => Object.assign({}, ...variants))
    .filter(obj => !bannedButtonVariants.some(variants => Object.entries(variants).every(([k, v]) => obj[k] === v)));
